export default function Impressum() {
  return (
    <div className="section">
      <h1>Impressum</h1>
      <p>Inhaber: Paul Muza</p>
      <p>Vertretungsberechtigte: Birgit Regier-Muza</p>
      <p>Postadresse: Waldweg 17, 24321 Lütjenburg</p>
      <p>Telefonnummer: +49 1707 180 642</p>
      <p>E-Mail Addresse: birgit@muza-store.de</p>
      <p>Umsatzsteueridentifikationsnummer: DE315458292 - gemäß §27a Umsatzsteuergesetz</p>
    </div>
  );
}
